class VariantPickers extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.section) {
      this.productContainer = document.getElementById(
        "ProductHero-" + this.dataset.section
      );
    }

    this.handleProductPickerLinkClick =
      this.handleProductPickerLinkClick.bind(this);
    this.productLinks = Array.from(
      this.querySelectorAll(".product-option-picker__product-link")
    );

    if (this.dataset.productPickerApp === "true") {
      this.productLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
          this.handleProductPickerLinkClick(event, event.currentTarget);
        });
      });
    }

    this.optionNames = this.dataset.optionNames
      ? this.dataset.optionNames.split(",")
      : [];
    this.onVariantChange(false);

    this.addEventListener("change", (e) => {
      if (
        e.target.classList.contains(
          "product-option-picker__product-link-select"
        ) ||
        e.target.classList.contains("product-option-picker__product-link-radio")
      ) {
        this.handleProductPickerLinkClick(e, e.target);
      } else {
        this.onVariantChange(true, e.target);
      }
    });
  }

  handleProductPickerLinkClick(event, target) {
    const targetTagName = target.tagName.toLowerCase();
    const selectedLinkEl =
      targetTagName === "select"
        ? target.options[target.selectedIndex]
        : target;

    const selectedProductLink =
      selectedLinkEl && (selectedLinkEl.href || selectedLinkEl.dataset.href);
    if (!selectedProductLink) {
      return;
    }
    if (this.dataset.productPickerApp !== "true") {
      if (targetTagName === "select") {
        window.location.href = selectedProductLink;
      }
      return;
    }

    if (targetTagName === "a") {
      event.preventDefault();
    }

    this.selectedProductLink = selectedProductLink;

    this.productLinks.forEach((link) => {
      if (link.href === selectedProductLink) {
        link.setAttribute("aria-current", "page");
      } else {
        link.removeAttribute("aria-current");
      }
    });
    const requestedProductLink = this.selectedProductLink;
    this.updateOptions();
    this.updateOptionLabels();

    const selectedProductRenderLink = `${this.selectedProductLink}${
      this.selectedProductLink.indexOf("?") === -1 ? "?" : "&"
    }section_id=${this.dataset.section}`;

    window.history.pushState({}, "", this.selectedProductLink);

    this.toggleAddButton(true);

    fetch(selectedProductRenderLink)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (requestedProductLink !== this.selectedProductLink) {
          return;
        }

        const sectionContainer = document.getElementById(
          `shopify-section-${this.dataset.section}`
        );
        const html = new DOMParser().parseFromString(responseText, "text/html");

        this.updateMedia(html, sectionContainer);

        const headSource = html.querySelector(".product-hero__head-meta");
        const headDestination = sectionContainer.querySelector(
          ".product-hero__head-meta"
        );
        if (headSource && headDestination) {
          headDestination.innerHTML = headSource.innerHTML;
          const headScripts = Array.from(
            headDestination.querySelectorAll("script")
          );
          headScripts.forEach((headScript) => {
            const execScript = document.createElement("script");
            Array.from(headScript.attributes).forEach((attr) => {
              execScript.setAttribute(attr.nodeName, attr.nodeValue);
            });
            execScript.innerHTML = headScript.innerHTML;
            headScript.parentNode.appendChild(execScript);
            headScript.parentNode.removeChild(headScript);
          });
        }

        const variantPickerSource = html.getElementById(this.id);
        if (variantPickerSource) {
          const lazyImages = Array.from(
            variantPickerSource.querySelectorAll('img[loading="lazy"]')
          );
          lazyImages.forEach(function (img) {
            img.loading = "eager";
          });
          this.parentElement.replaceChild(variantPickerSource, this);
        }
      })
      .catch((_err) => {
        console.log("error", _err);
        if (requestedProductLink === this.selectedProductLink) {
          window.location.href = this.selectedProductLink;
        }
        this.toggleAddButton(false);
      });

    return false;
  }

  onVariantChange(updateContent) {
    this.updateOptions();
    this.updateMasterId();

    this.updateOptionRestrictedContent();
    this.updateProductRestrictedContent();

    if (this.currentVariant) {
      this.updateVariantID();
      this.updateVariantInput();
      if (updateContent) {
        this.updateContent();
      }
      this.updateProductPickerLinks();
      this.updateOptionLabels();
      this.toggleAddButton(!this.currentVariant.available, true);

      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          variant: this.currentVariant,
        },
      });
    }
  }

  updateContent() {
    this.updateURL();

    const fetchingVariant = this.currentVariant.id;
    fetch(
      `${window.location.pathname}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== fetchingVariant) {
          return;
        }

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sectionContainer = document.getElementById(
          `shopify-section-${this.dataset.section}`
        );

        const updateSourceFromDestination = (selector, outer = false) => {
          const sources = html.querySelectorAll(selector);
          const destinations = sectionContainer.querySelectorAll(selector);
          sources.forEach((source, index) => {
            const destination = destinations[index];
            if (source && destination) {
              const htmlProp = outer ? "outerHTML" : "innerHTML";
              destination[htmlProp] = source[htmlProp];
            }
          });
        };

        updateSourceFromDestination(".product-price-container", true);
        updateSourceFromDestination(".product-hero__title-container");

        this.updateMedia(html, sectionContainer);
      });
  }

  toggleAddButton(disable = true, changeText) {
    if (this.dataset.unavailable === "true") {
      return;
    }
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector(".js-add-to-cart-text");
    const fixedCtaButton = document.querySelector(".js-fixed-cta");
    if (!addButton) return;

    let text;
    if (changeText) {
      text = disable
        ? addButton.dataset.unavailableText || "Sold Out"
        : addButton.dataset.addToCartText || "Add to Cart";
    }

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
      if (fixedCtaButton) {
        fixedCtaButton.setAttribute("disabled", "disabled");
        if (text) {
          fixedCtaButton.textContent = /add to cart/i.test(text)
            ? "Add to Cart"
            : text;
        }
      }
    } else {
      addButton.removeAttribute("disabled");
      if (text) {
        addButtonText.textContent = text;
      }
      if (fixedCtaButton) {
        fixedCtaButton.removeAttribute("disabled");
        if (text) {
          fixedCtaButton.textContent = /add to cart/i.test(text)
            ? "Add to Cart"
            : text;
        }
      }
    }
  }

  updateMediaList(mediaGallerySource, mediaGalleryDestination) {
    let shouldRefresh = false;
    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(
        mediaGallerySource.querySelectorAll("li[data-media-id]")
      );
      const sourceSet = new Set(
        mediaGallerySourceItems.map((item) => item.dataset.mediaId)
      );
      const sourceMap = new Map(
        mediaGallerySourceItems.map((item, index) => [
          item.dataset.mediaId,
          { item, index },
        ])
      );
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(
        mediaGalleryDestination.querySelectorAll("li[data-media-id]")
      );
      const destinationSet = new Set(
        mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
      );

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh)
        [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach(
        (destinationItem, destinationIndex) => {
          const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

          if (sourceData && sourceData.index !== destinationIndex) {
            mediaGallerySource.insertBefore(
              sourceData.item,
              mediaGallerySource.querySelector(
                `li:nth-of-type(${destinationIndex + 1})`
              )
            );

            // refresh source now that it has been modified
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();
          }
        }
      );
    }

    return shouldRefresh;
  }

  updateMedia(html, sectionContainer) {
    const mediaListSources = [
      sectionContainer.querySelector(".embla-thumbs__container"),
    ];
    const mediaListDestinations = [
      html.querySelector(".embla-thumbs__container"),
    ];

    const modalSource = document.querySelector(
      `[id^="ProductModal-${this.dataset.section}"]`
    );
    const modalDestination = html.querySelector('[id^="ProductModal-"]');
    if (modalSource && modalDestination) {
      mediaListSources.push(
        modalSource.querySelector(".product-media-modal__media-list")
      );
      mediaListDestinations.push(
        modalDestination.querySelector(".product-media-modal__media-list")
      );
      mediaListSources.push(
        modalSource.querySelector(".embla-thumbs__container")
      );
      mediaListDestinations.push(
        modalDestination.querySelector(".embla-thumbs__container")
      );
    }
    mediaListSources.push(sectionContainer.querySelector(".embla__container"));
    mediaListDestinations.push(html.querySelector(".embla__container"));

    let reInit = false;
    mediaListSources.forEach((source, index) => {
      const destination = mediaListDestinations[index];
      if (!source && destination) {
        return;
      }
      if (this.updateMediaList(source, destination) && index === 0) {
        reInit = true;
      }
    });

    if (reInit) {
      const mediaGallerySource = sectionContainer.querySelector(
        `[id^="MediaGallery-${this.dataset.section}"]`
      );
      mediaGallerySource.reInit(0);
    }
  }

  updateVariantID() {
    document.querySelector(".product-price-container").dataset.variantId =
      this.currentVariant.id;
  }

  updateOptionRestrictedContent() {
    if (!this.productContainer) {
      return;
    }

    const restrictedBlocks = Array.from(
      this.productContainer.querySelectorAll(
        ".product-hero__option-restricted-block"
      )
    );
    restrictedBlocks.forEach((block) => {
      if (block.getAttribute("data-option-1") === "NO VARIANT SELECTED") {
        block.hidden = !!this.options.length;
      } else {
        const failedMatch = this.options.find((value, index) => {
          const blockVal = block.getAttribute("data-option-" + (index + 1));
          return blockVal ? blockVal !== value : false;
        });
        block.hidden = this.options.length ? !!failedMatch : true;
      }
    });
  }
  updateProductRestrictedContent() {
    if (!this.productContainer) {
      return;
    }

    const restrictedBlocks = Array.from(
      this.productContainer.querySelectorAll(
        ".product-hero__product-restricted-block"
      )
    );

    restrictedBlocks.forEach((block) => {
      const products = block.dataset.productRestriction
        ? block.dataset.productRestriction.split(",")
        : [];
      if (!this.dataset.product) {
        block.hidden = products.length > 0;
      } else {
        block.hidden = !products.includes(this.dataset.product);
      }
    });
  }

  updateProductPickerLinks() {
    if (!this.currentVariant) {
      return;
    }
    const productLinks = Array.from(
      this.querySelectorAll(".product-option-picker__product-link")
    );
    productLinks.forEach((link) => {
      try {
        const variantMap = link.dataset.variantMap.split(",").reduce((m, v) => {
          const variantDef = v.split(":");
          const variantId = variantDef.shift();
          m[variantDef.join(":")] = variantId;
          return m;
        }, {});
        const variantId = variantMap[this.currentVariant.title];
        if (variantId) {
          const productLink = link.href.split("?")[0];
          link.href = `${productLink}?variant=${variantId}`;
        }
      } catch (error) {}
    });

    const productPickerDropdown = this.querySelector(
      ".product-option-picker__product-link-select"
    );
    if (productPickerDropdown) {
      for (
        let optionIndex = 0;
        optionIndex < productPickerDropdown.options.length;
        optionIndex++
      ) {
        const optionEl = productPickerDropdown.options[optionIndex];
        try {
          const variantMap = optionEl.dataset.variantMap
            .split(",")
            .reduce((m, v) => {
              const variantDef = v.split(":");
              const variantId = variantDef.shift();
              m[variantDef.join(":")] = variantId;
              return m;
            }, {});
          const variantId = variantMap[this.currentVariant.title];
          if (variantId) {
            optionEl.dataset.href = `${
              optionEl.dataset.href.split("?")[0]
            }?variant=${variantId}`;
          }
        } catch (error) {}
      }
    }
  }

  updateOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll("fieldset,.product-form__input")
    );
    this.options = [];
    fieldsets.forEach((fieldset) => {
      const radioButtons = Array.from(fieldset.querySelectorAll("input"));
      if (radioButtons.length) {
        const checked = radioButtons.find((radio) => radio.checked);
        if (checked) {
          const optionIndex = this.optionNames.indexOf(checked.name);
          if (optionIndex !== -1) {
            this.options[optionIndex] = checked.value;
          }
        }
      }
      const select = fieldset.querySelector("select");
      if (select) {
        const optionIndex = this.optionNames.indexOf(select.name);
        if (optionIndex !== -1) {
          this.options[optionIndex] = select.value;
        }
      }
    });
    this.optionsMap = this.options.reduce((map, value, index) => {
      map[this.optionNames[index]] = value;
      return map;
    }, {});
    const selectedPickerLinks = Array.from(
      this.querySelectorAll(
        ".product-option-picker__product-link[aria-current='page']"
      )
    );
    selectedPickerLinks.forEach((el) => {
      this.optionsMap[el.dataset.optionName] = el.dataset.optionValue;
    });
    const productPickerDropdown = this.querySelector(
      ".product-option-picker__product-link-select"
    );
    const selectedPickerOption =
      productPickerDropdown &&
      productPickerDropdown.options[productPickerDropdown.selectedIndex];
    if (selectedPickerOption) {
      this.optionsMap[selectedPickerOption.dataset.optionName] =
        selectedPickerOption.dataset.optionValue;
    }
    const selectedProductRadioButton = this.querySelector(
      ".product-option-picker__product-link-radio:checked"
    );
    if (selectedProductRadioButton) {
      this.optionsMap[selectedProductRadioButton.dataset.optionName] =
        selectedProductRadioButton.dataset.optionValue;
    }
  }

  updateMasterId() {
    this.currentVariant = this.getProductData().variants.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updatePrice() {
    let priceContainers = [
      ...document.querySelectorAll(".product-price-container"),
    ];
    let currencySymbol = window.currencySymbol;
    let { price: variantPrice, compare_at_price: variantComparePrice } =
      this.currentVariant || this.getProductData();

    priceContainers.forEach((priceContainer) => {
      let priceElement = priceContainer.querySelector(".product-price");
      let comparePriceElement = priceContainer.querySelector(
        ".product-compare-price"
      );

      if (variantPrice && variantPrice > 0 && priceElement) {
        priceElement.textContent = `${currencySymbol || "$"}${(
          variantPrice / 100
        ).toFixed(2)}`;
        if (priceContainer.dataset.priceVaries === "true") {
          priceElement.textContent += "+";
        }
      }

      if (
        variantComparePrice &&
        variantComparePrice > 0 &&
        comparePriceElement
      ) {
        comparePriceElement.textContent = `${currencySymbol || "$"}${(
          variantComparePrice / 100
        ).toFixed(2)}`;
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  updateOptionLabels() {
    const fieldsets = Array.from(this.querySelectorAll(".product-form__input"));
    fieldsets.forEach((option) => {
      const optionName = option.dataset.option;
      const label = option.querySelector(".js-option-selected-value");
      if (label && this.optionsMap[optionName]) {
        label.textContent = this.optionsMap[optionName];
      }
    });
  }

  getProductData() {
    this.productData =
      this.productData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.productData;
  }
}

customElements.define("variant-pickers", VariantPickers);
